import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/StudyCalculatorImg.webp";
const TITLE = "Konversi IPK Universitas ke Sistem Jerman - Sarjana dan Magister";
const DESCRIPTION =
  "Konversi IPK Anda ke sistem Jerman dengan mudah dan akurat. Pelajari cara mengkonversi nilai sarjana dan magister ke sistem Jerman menggunakan alat yang berguna ini.";
const KEYWORDS =
  "konversi IPK universitas, konversi ke sistem Jerman, konversi nilai sarjana, konversi nilai magister, IPK universitas, sistem Jerman";
const OG_URL = "https://do-calculate.com/calculator/id/gradetogerman";
function GradeToGerman() {
  const [originalValue, setOriginalValue] = useState("");
  const [convertedValue, setConvertedValue] = useState("");
  const [conversionType, setConversionType] = useState("grade");
  const [showResult, setShowResult] = useState(false);
  const [error, setError] = useState(null);
  const calculateGrade = (value) => {
    if (conversionType === "grade") {
      const grade = parseFloat(value);
      if (!isNaN(grade) && grade >= 0 && grade <= 100) {
        return (1 + (3 * (4 - grade / 25)) / 3).toFixed(2);
      }
    } else if (conversionType === "gpa") {
      const gpa = parseFloat(value);
      if (!isNaN(gpa) && gpa >= 0 && gpa <= 4) {
        return (1 + (3 * (4 - gpa)) / 3).toFixed(2);
      }
    }
    return "Input tidak valid";
  };
  const getGradeTerm = (value) => {
    const grade = parseFloat(value);
    if (grade >= 1.0 && grade <= 1.5) {
      return "Sangat Baik";
    } else if (grade >= 1.6 && grade <= 2.5) {
      return "Baik Sekali";
    } else if (grade >= 2.6 && grade <= 3.5) {
      return "Baik";
    } else if (grade >= 3.6 && grade <= 4.0) {
      return "Cukup";
    } else if (grade >= 4.1 && grade <= 5.0) {
      return "Gagal";
    } else {
      return "Input tidak valid";
    }
  };
  const handleCalculateClick = () => {
    const converted = calculateGrade(originalValue);
    setConvertedValue(converted);
    setShowResult(true);
    setError(null);
  };
  const handleConversionTypeChange = (newConversionType) => {
    setConversionType(newConversionType);
    setOriginalValue("");
    setConvertedValue("");
    setShowResult(false);
    setError(null);
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Konversi IPK Anda (persentase atau IPK) ke sistem Jerman dengan mudah dan akurat. Pelajari cara mengkonversi nilai sarjana dan magister ke sistem Jerman menggunakan alat yang berguna ini.
                </p>
              </div>
              <br />
            </div>
            <hr />
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>
                    Konversi IPK Universitas ke Sistem Jerman
                  </h2>
                </div>
                <hr />
                <div className="form-group">
                  <b>
                    <label>Jenis Nilai:</label>
                  </b>
                  <div>
                    <input
                      type="radio"
                      id="gradeConversion"
                      name="conversionType"
                      value="grade"
                      checked={conversionType === "grade"}
                      onChange={() => handleConversionTypeChange("grade")}
                      className="form-check-input"
                      style={{ marginLeft: "4px" }}
                    />
                    <label
                      htmlFor="gradeConversion"
                      className="form-check-label"
                    >
                      Persentase (100)
                    </label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="gpaConversion"
                      name="conversionType"
                      value="gpa"
                      checked={conversionType === "gpa"}
                      onChange={() => handleConversionTypeChange("gpa")}
                      className="form-check-input"
                      style={{ marginLeft: "4px" }}
                    />
                    <label htmlFor="gpaConversion" className="form-check-label">
                      IPK (4.00)
                    </label>
                  </div>
                </div>
                <br />
                <div>
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label htmlFor="originalValue">
                        {conversionType === "grade"
                          ? "Nilai Persentase:"
                          : "IPK:"}
                      </label>
                    </b>
                    <input
                      type="text"
                      value={originalValue}
                      id="originalValue"
                      onChange={(e) => setOriginalValue(e.target.value)}
                      className="form-control"
                      style={{ width: "200px", marginRight: "4px" }}
                    />
                  </div>
                  <div>
                    <br />
                  </div>
                </div>
                <button
                  className="btn btn-success mt-3"
                  onClick={handleCalculateClick}
                >
                  Hitung
                </button>
                <br />
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-sm-12 col-md-7">
                {error && (
                  <div className="alert alert-warning">
                    <b>
                      <u>Error:</u>
                    </b>{" "}
                    {error}
                  </div>
                )}
                {showResult &&  (
                  <div
                    style={{ fontSize: "15px" }}
                    className="bg-light bg-gradient text-dark"
                  >
                    <div className="p-3 bg-success bg-gradient text-white">
                      <strong>Hasil:</strong>
                    </div>
                    <b>
                      {conversionType === "grade"
                        ? `Nilai Persentase dalam Sistem Jerman: ${convertedValue} (${getGradeTerm(
                            convertedValue
                          )})`
                        : `IPK dalam Sistem Jerman: ${convertedValue} (${getGradeTerm(
                            convertedValue
                          )})`}
                    </b>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE}</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Sistem Klasifikasi Nilai Universitas di Jerman
                    </h2>
                  </u>
                  <p>
                    Di Jerman, nilai diklasifikasikan pada skala dari 1.0 hingga 5.0, dengan 1.0 adalah yang terbaik dan 5.0 adalah yang terburuk. Nilai dapat dibagi sebagai berikut:
                  </p>
                  <table >
                    <thead>
                      <tr className="bmi-header">
                        <th>Nilai Jerman</th>
                        <th>Istilah Inggris Setara</th>
                        <th>Persentase Setara</th>
                        <th>IPK (Skala 5 Poin)</th>
                       </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1.0 – 1.5</td>
                         <td>Sangat Baik</td>
                         <td>90-100%</td>
                         <td>5</td>
                       </tr>
                       <tr>
                         <td>1.6 – 2.5</td>
                         <td>Baik Sekali</td>
                         <td>80-89%</td>
                         <td>4</td>
                       </tr>
                       <tr>
                         <td>2.6 – 3.5</td>
                         <td>Baik</td>
                         <td>65-79%</td>
                         <td>3</td>
                       </tr>
                       <tr>
                         <td>3.6 – 4.0</td>
                         <td>Cukup</td>
                         <td>50-64%</td>
                         <td>2</td>
                       </tr>
                       <tr>
                         <td>4.1 – 5.0</td>
                         <td>Gagal</td>
                         <td>0-49%</td>
                         <td>1</td>
                       </tr>
                    </tbody>
                  </table>
                  <p>
                    Informasi ini membantu memahami cara mengkonversi nilai ke sistem Jerman dan mengetahui persentase setaranya.
                  </p>
                  <b className="text-primary">
                    <span>Contoh: </span>
                    Jika Anda memiliki IPK 3.0 pada skala 4.0, Anda dapat mengkonversinya ke sistem Jerman menggunakan alat di atas dan Anda akan mendapatkan hasil yang setara.
                  </b>
                  <p>
                    Alat ini sangat berguna bagi mahasiswa internasional yang ingin melanjutkan studi di Jerman atau melamar pekerjaan yang membutuhkan IPK tertentu.
                  </p>
                  <div>
                    <p>
                      Jerman adalah salah satu negara terpenting yang maju secara ilmiah, dengan universitas tertua yang menjadi tujuan mahasiswa dari seluruh dunia, terutama dari negara-negara Arab.
                    </p>
                    <p className="alert alert-info">
                      Di Jerman terdapat 15 universitas yang termasuk dalam 200 universitas terbaik di dunia, selain itu sistem studi di universitas Jerman dikenal dengan ketelitian ilmiah dan kebaruan kurikulum. Alasan lain adalah biaya studi yang murah dibandingkan dengan negara-negara Eropa lainnya, Inggris, dan Amerika Serikat.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default GradeToGerman;